import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropLogs } from "./SingleWaveDropLogs";
import { SingleWaveDropVoters } from "./SingleWaveDropVoters";
import Download from "@/components/download/Download";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
interface SingleWaveDropInfoDetailsProps {
  readonly drop: ExtendedDrop | undefined;
}
export const SingleWaveDropInfoDetails: React.FC<SingleWaveDropInfoDetailsProps> = t0 => {
  const $ = _c(19);
  const {
    drop
  } = t0;
  let t1;
  let t2;
  if ($[0] !== drop?.author?.handle || $[1] !== drop?.metadata || $[2] !== drop?.parts || $[3] !== drop?.title || $[4] !== drop?.wave) {
    const media = drop?.parts?.at(0)?.media?.at(0);
    const fileInfo = getFileInfoFromUrl(media?.url);
    let t3;
    if ($[7] !== drop?.metadata || $[8] !== drop?.title) {
      t3 = drop?.metadata?.find(_temp)?.data_value ?? drop?.title;
      $[7] = drop?.metadata;
      $[8] = drop?.title;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const title = t3;
    const author = drop?.author?.handle;
    const wave = drop?.wave.name;
    let fileName = title;
    if (wave) {
      fileName = fileName + ` for ${wave}`;
    }
    if (author) {
      fileName = fileName + ` by @${author}`;
    }
    t1 = "tw-px-6 tw-space-y-4 tw-pb-6 tw-pt-4";
    t2 = media && fileInfo && <div className="tw-flex tw-justify-between tw-items-center"><span className="tw-text-sm tw-font-medium">Media Type: {fileInfo.extension.toUpperCase()}</span><Download href={media.url} name={fileName ?? fileInfo.name} extension={fileInfo.extension} /></div>;
    $[0] = drop?.author?.handle;
    $[1] = drop?.metadata;
    $[2] = drop?.parts;
    $[3] = drop?.title;
    $[4] = drop?.wave;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[10] !== drop) {
    t3 = drop && <SingleWaveDropVoters drop={drop} />;
    $[10] = drop;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== drop) {
    t4 = drop && <SingleWaveDropLogs drop={drop} />;
    $[12] = drop;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
function _temp(m) {
  return m.data_key === "title";
}